import { useSettings } from "@/context/SettingsContext";

export default function SEO({ title, description, canonical, image, type = "website", schema }) {
  const { settings } = useSettings();
  const seo = settings?.seo || {};
  const finalTitle = title || seo.default_title || "NewStarAds";
  const finalDesc = description || seo.default_description || "";
  const finalImage = image || seo.og_image || "";
  const url = canonical || (typeof window !== "undefined" ? window.location.href : "https://newstarads.com");
  const robots = seo.robots || "index, follow";

  return (
    <>
      <title>{finalTitle}</title>
      <meta name="description" content={finalDesc} />
      <meta name="robots" content={robots} />
      {seo.keywords && <meta name="keywords" content={seo.keywords} />}
      <link rel="canonical" href={url} />
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDesc} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      {finalImage && <meta property="og:image" content={finalImage} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={finalTitle} />
      <meta name="twitter:description" content={finalDesc} />
      {finalImage && <meta name="twitter:image" content={finalImage} />}
      {schema && <script type="application/ld+json">{JSON.stringify(schema)}</script>}
    </>
  );
}
